import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react";
import { IMAGES, CONTACT } from "@/lib/content";
import { useConsult } from "@/App";

export default function Footer() {
  const { openConsult } = useConsult();
  return (
    <footer className="border-t border-gold/15 bg-navy-deep" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src={IMAGES.logo} alt="Elite Imperium Digital" className="h-14 w-auto rounded-sm" />
            <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-slate-400">
              The technology consultancy of Antigua &amp; Barbuda. We turn island visitors into bookings and remove the
              manual admin that slows Caribbean business down — built to international standards, led from Antigua
              and Barbuda.
            </p>
            <p className="mt-6 font-mono text-xs tracking-widest text-gold/70">17.0608° N, 61.7964° W — ANTIGUA &amp; BARBUDA</p>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold/80">Explore</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              {[["Services", "/services"], ["Free Audit", "/audit"], ["About", "/about"], ["Insights", "/insights"], ["Privacy", "/privacy"]].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="transition-colors duration-300 hover:text-gold-glow">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold/80">Company</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li><Link to="/contact" data-testid="footer-link-contact" className="transition-colors duration-300 hover:text-gold-glow">Contact</Link></li>
              <li>
                <button onClick={openConsult} data-testid="footer-book-btn" className="inline-flex items-center gap-1 transition-colors duration-300 hover:text-gold-glow">
                  Book Consultation <ArrowUpRight className="h-3.5 w-3.5" />
                </button>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold/80">Reach us</p>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold/70" />{CONTACT.office}</li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 shrink-0 text-gold/70" />{CONTACT.email}</li>
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 shrink-0 text-gold/70" />{CONTACT.phone} · {CONTACT.phone_uk}</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-gold/10 pt-8 text-xs text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} Elite Imperium Digital. A member of the Elite Imperium Group.</p>
          <p className="font-mono tracking-wider">BASED IN ANTIGUA &amp; BARBUDA</p>
        </div>
      </div>
    </footer>
  );
}
